
import React, { useState, useRef, useEffect } from "react";
import userIcon from "../../../../common/assets/images/user-icon.png";
import generalsurgeryIcon from "../../../../common/assets/images/general-surgery-icon.png";
import backIcon from "../../../../common/assets/images/back-icon.png";
import { useNavigate } from "react-router-dom";

const AuditorSideDrawer = ({
    auditorQueues,
    auditorViewData,
    isAuditorQueueFetching,
    queuesError,
    auditorViewStatsLoading,
    getStatsDetails,
    hanldeSelectQueueEpisodes,
}) => {
    const [openSection, setOpenSection] = useState(null); // 'queues' | 'tasks' | 'stats' | null
    const menuRef = useRef(null);
    const navigate = useNavigate();

    // Data extraction
    const queues = auditorQueues || [];
    const tasksCount = auditorViewData?.for_audited?.[0]?.number_of_episodes ?? 0; // My Tasks count
    const stats = getStatsDetails() || {};

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setOpenSection(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="mobile-qc-menu" ref={menuRef}>
            {/* Vertical navigation buttons */}
            <div className="mobile-qc-button-container">
                <button
                    className={`mobile-qc-toggle-btn ${openSection === "queues" ? "active" : ""}`}
                    onClick={() => setOpenSection(openSection === "queues" ? null : "queues")}
                >
                    Queues
                </button>
                <button
                    className={`mobile-qc-toggle-btn ${openSection === "tasks" ? "active" : ""}`}
                    onClick={() => setOpenSection(openSection === "tasks" ? null : "tasks")}
                >
                    My Tasks
                </button>
                <button
                    className={`mobile-qc-toggle-btn ${openSection === "stats" ? "active" : ""}`}
                    onClick={() => setOpenSection(openSection === "stats" ? null : "stats")}
                >
                    My Stats
                </button>
            </div>

            {/* Collapsible Sections */}

            {openSection === "queues" && (
                <div className="mobile-qc-dropdown">
                    {isAuditorQueueFetching ? (
                        <div className="mobile-qc-item">
                            <img src={generalsurgeryIcon} alt="loading" className="mobile-qc-icon" />
                            <span>Loading...</span>
                        </div>
                    ) : queuesError ? (
                        <div className="mobile-qc-item error">No queues found</div>
                    ) : (
                        queues.map((item) => (
                            <div
                                key={item.queue_id}
                                className="mobile-qc-item"
                                onClick={hanldeSelectQueueEpisodes ? () => hanldeSelectQueueEpisodes("queue", item) : undefined}
                            >
                                <img src={generalsurgeryIcon} alt="icon" className="mobile-qc-icon" />
                                <span>
                                    {item.queue_name} ({item.number_of_episodes})
                                </span>
                            </div>
                        ))
                    )}
                </div>
            )}

            {openSection === "tasks" && (
                <div className="mobile-qc-dropdown">
                    <div className="mobile-qc-item">
                        <img src={generalsurgeryIcon} alt="task" className="mobile-qc-icon" />
                        <span>For Audit ({tasksCount})</span>
                    </div>
                </div>
            )}

            {openSection === "stats" && (
                <div className="mobile-qc-dropdown">
                    {auditorViewStatsLoading ? (
                        <div className="mobile-qc-item">
                            <span>Loading...</span>
                        </div>
                    ) : (
                        <div className="mobile-qc-stats">
                            <div className="stats-value-wrapper">
                                <label>Audited</label>
                                <span>{stats.total_number_of_episodes || 0}</span>
                            </div>
                            <div className="stats-value-wrapper">
                                <label>NWAU</label>
                                <span>{stats.total_weight ? stats.total_weight.toFixed(4) : 0}</span>
                            </div>
                            <div className="stats-value-wrapper">
                                <label>$</label>
                                <span>
                                    {stats.total_weight
                                        ? Math.round(stats.total_weight * 6465).toLocaleString()
                                        : 0}
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            )}

        </div>
    );
};

export default AuditorSideDrawer;